import classNames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import useStyles from './styles';
import IHeroBannerContent from './types';

function HeroBannerContent({
  className,
  heading,
  content,
  imgSrc,
  imgAlt,
  imgContainerClassName,
  contentClassName,
  partialBg,
}: IHeroBannerContent) {
  const classes = useStyles();

  return (
    <section className={classNames(classes.root, className, { partialBg })}>
      <article className={classes.banner}>
        <div className={classNames(classes.bannerContent)}>
          <div className={classNames(classes.imgContainer, imgContainerClassName)}>
            <LazyLoadImage src={imgSrc} alt={imgAlt} />
          </div>

          <h1 className={classes.heading}>{heading}</h1>
        </div>
        {content && <p className={classNames(classes.content, contentClassName)}>{content}</p>}
      </article>
    </section>
  );
}

export default HeroBannerContent;
